export class Listing {
    title: string;
    thumbnail: string;
}

export class Contact {
  AgentID: number;
  emails: string;
  FirstName: string;
  LastName: string;
  Notes: string;
  Phones: string;
  intType: number;
  Types: string;
  intModeType: number;
  PreferredMode: string;
  ActivityBy: number;
}

export class LogActivity {
  AgentID: number;
	Activity: string; // 1.VisitProfile 2.ContactMeInitiate
	ActivityBy: number;
}
